// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3890) return "static/chunks/3890-f64210ce462b6582.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7679":"46b97596","8388":"2fbf9dd2"}[chunkId] || chunkId) + "." + {"1796":"377975a53832201a","7679":"cb002d63f7f48cfd","8388":"40c8469bb02fe0fb"}[chunkId] + ".js";
};